import axios from "axios";
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

export default function addStudentToMultiClass(classID, studentIDs) {

  if(typeof classID != "number" || !Array.isArray(studentIDs)){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing or wrong type of params: classID:number, studentIDs:[...studentID]')
      })
    })
	}

  const toServer = {
    students_list: studentIDs,
	}

	return new Promise((resolve, reject) => {
		axios.put(APIAddress, {'uri': `/multi_joinclass/${classID}/`,
    'data': JSON.stringify(toServer),
    'method': 'POST',
    'token': localStorage.getItem('token')})
    .then((res) => {
			resolve(res.data);
		})
		.catch((err) => {
			console.error(err);
			reject(err);
		})
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/class/addStudentToMultiClass.js